export default {
    en: {
        id: 'exercise6',
        title: 'You should not consider a vendor capture strategy',
        titles: [' Your warehouses are neither large enough nor ideally located', 'Even if they were, the approach requires double handling', 'Even if you accept that, the possible admin-mileage savings are negligible'],
        boxes: [
            {
                name: 'box1',
                title: 'Time',
            },
            {
                name: 'box2',
                title: 'Structure',
            },
            {
                name: 'box3',
                title: 'Degree',
            }
        ],
        correctAnswers: {
            box1: false,
            box2: true,
            box3: false
        },
        userAnswers: {
            box1: false,
            box2: false,
            box3: false
        },
        text: 'This is a particular form of structural order.  You imagine yourself going first to the location, then inside the building to look at the approach, then inside the approach to assess the savings that result.  I call this a “vertical” structure, in contrast to the “horizontal” structure illustrated in the Board Mill example above.'
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/i18n/exercise6.js